import DateTimePicker from 'react-datetime-picker';
// TODO: document whatever this is
import { RRule } from 'rrule';
import Split from '../Shared/Split';
import moment from 'moment';
import { Button } from 'reactstrap';
import { Field, Form } from 'react-final-form';
import { actions } from '../../context';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

const SyncScheduleForm = (props) => {
    const dispatch = useDispatch();
    const { practiceId, nextSyncDate, configuration = {}, cancel } = props;

    const [customPristine, setCustomPristine] = useState(true);
    const [syncDate, setSyncDate] = useState(new Date());
    const [syncFrequency, setSyncFrequency] = useState(3);
    const [syncInterval, setSyncInterval] = useState(1);

    const updateDate = (value) => {
        setCustomPristine(false);
        setSyncDate(value);
    };

    const reset = (form) => {
        form.reset();
        setCustomPristine(true);
        resetPracticeSync();
        resetPracticeRunRule();
    };

    const submit = async (vals) => {
        const payload = {
            ...configuration,
            nextRun: moment(syncDate).unix(),
            runRule: new RRule({
                freq: vals.frequency,
                interval: vals.interval,
            }).toString(),
        };
        dispatch(
            actions.practice.savePracticeConfiguration(practiceId, payload)
        ).then(() => {
            cancel();
            dispatch(actions.toggle.triggerPracticeRefresh());
        });
    };

    const resetPracticeSync = () => {
        if (nextSyncDate > 0) {
            setSyncDate(new Date(nextSyncDate * 1000));
        }
    };

    const resetPracticeRunRule = () => {
        if (configuration && configuration.runRule) {
            setSyncFrequency(
                RRule.fromString(configuration.runRule || '').options.freq
            );
            setSyncInterval(
                RRule.fromString(configuration.runRule || '').options.interval
            );
        }
    };

    useEffect(() => {
        resetPracticeSync();
        resetPracticeRunRule();
        // eslint-disable-next-line
    }, [dispatch, practiceId, configuration]);

    const frequencies = [
        // {label: "Hour", value: 4},
        { label: 'Days', value: 3 },
        { label: 'Weeks', value: 2 },
        { label: 'Months', value: 1 },
        { label: 'Years', value: 0 },
    ];

    return (
        <Form
            initialValues={{
                interval: syncInterval,
                frequency: syncFrequency,
            }}
            onSubmit={submit}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit}>
                    <div className="w-100 mb-4 d-flex">
                        <div className="w-50">
                            <h5>Sync every</h5>
                            <Field
                                name="interval"
                                className="p-2 rounded text-center mx-1"
                                component="input"
                                type="number"
                                style={{ width: '64px' }}
                                min="1"
                            />
                            <Field
                                className="p-2 rounded mx-1"
                                name="frequency"
                                component="select">
                                {frequencies.map((f) => (
                                    <option key={f.value} value={f.value}>
                                        {f.label}
                                    </option>
                                ))}
                            </Field>
                        </div>
                        <div className="w-50">
                            <h5>Next Sync Date</h5>
                            <DateTimePicker
                                value={syncDate}
                                onChange={updateDate}
                                className="text-dark bg-light p-2 rounded"
                            />
                        </div>
                    </div>
                    <Split>
                        <Button
                            color="danger"
                            className="mx-1"
                            disabled={pristine && customPristine}
                            onClick={() => reset(form)}>
                            Clear
                        </Button>
                        <div>
                            <Button
                                color="danger"
                                className="mx-1"
                                onClick={cancel}>
                                Cancel
                            </Button>
                            <Button
                                color="success"
                                disabled={pristine && customPristine}
                                type="submit">
                                Submit
                            </Button>
                        </div>
                    </Split>
                </form>
            )}
        />
    );
};

export default SyncScheduleForm;
